import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminAccountView.css';
import { API_BASE_URL } from '../config/apiConfig';

function AdminAccountView({ token }) {
  const [admin, setAdmin] = useState(null);
  const navigate = useNavigate();

  // 🔐 Token expiry check
  useEffect(() => {
    const expiry = localStorage.getItem('adminTokenExpiry');
    const isExpired = expiry && Date.now() > Number(expiry);

    if (!token || isExpired) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminTokenExpiry');
      localStorage.removeItem('adminUser');
      navigate('/admin/login');
    }
  }, [token, navigate]);

  // 📡 Fetch admin profile
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await res.json();
        setAdmin(data);
      } catch {
        setAdmin(null);
      }
    };

    fetchAdmin();
  }, [token]);

  return admin ? (
    <div className="account-view">
      <h2>👤 Admin Profile</h2>
      <p><strong>Name:</strong> {admin.name || 'N/A'}</p>
      <p><strong>Username:</strong> {admin.username}</p>
      <p><strong>Email:</strong> {admin.email}</p>
      <p><strong>Mobile:</strong> {admin.mobile}</p>
      <p><strong>Role:</strong> {admin.role}</p>
      <p><strong>Qualification:</strong> {admin.qualification || 'N/A'}</p>
    </div>
  ) : (
    <p>Loading account info...</p>
  );
}

export default AdminAccountView;
